import {z} from 'zod'

export const concreteUsageSchema = z.object({
  concreteUsage: z.string().optional()
})
